import React from "react";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";

/* ============================================================
   API
============================================================ */

const API =
  process.env.NODE_ENV === "production"
    ? "https://gj-frio-industrial-api.onrender.com"
    : "http://localhost:4000";

/* ============================================================
   OBTENER PORTADAS
============================================================ */

const obtenerPortadas = async () => {
  const respuesta = await axios.get(`${API}/api/carousel`, {
    timeout: 45000,
  });

  return Array.isArray(respuesta.data) ? respuesta.data : [];
};

/* ============================================================
   COMPONENTE
============================================================ */

const Carousel = () => {
  /* ==========================================================
     TANSTACK QUERY
  ========================================================== */

  const {
    data: portadas = [],
    isError,
    error,
  } = useQuery({
    queryKey: ["carousel-principal"],
    queryFn: obtenerPortadas,

    // La configuración principal ya está en queryClient.js.
    staleTime: Infinity,
    gcTime: Infinity,
  });

  /* ==========================================================
     ERROR
  ========================================================== */

  if (isError) {
    console.error("Error al cargar el carrusel principal:", error);
  }

  /* ==========================================================
     SIN PORTADAS
  ========================================================== */

  if (portadas.length === 0) {
    return null;
  }

  /* ==========================================================
     CARRUSEL
  ========================================================== */

  return (
    <div
      id="carouselExampleControls"
      className="carousel slide"
      data-bs-ride="carousel"
      data-bs-interval="5000"
      style={{
        width: "100%",
        backgroundColor: "#fff",
      }}
    >
      <div className="carousel-inner">
        {portadas.map((portada, index) => (
          <div
            key={portada._id}
            className={`carousel-item ${index === 0 ? "active" : ""}`}
          >
            <img
              src={portada.imagen}
              className="d-block w-100"
              alt={portada.titulo || `Portada G&J Frío ${index + 1}`}
              /* Primera portada prioritaria */
              loading={index === 0 ? "eager" : "lazy"}
              fetchpriority={index === 0 ? "high" : "low"}
              decoding="async"
              style={{
                width: "100%",
                height: "auto",
                display: "block",
                objectFit: "contain",
              }}
            />
          </div>
        ))}
      </div>

      {/* ======================================================
          CONTROLES
      ====================================================== */}

      {portadas.length > 1 && (
        <>
          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#carouselExampleControls"
            data-bs-slide="prev"
          >
            <span
              className="carousel-control-prev-icon bg-primary rounded-circle p-3"
              aria-hidden="true"
            ></span>

            <span className="visually-hidden">Anterior</span>
          </button>

          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#carouselExampleControls"
            data-bs-slide="next"
          >
            <span
              className="carousel-control-next-icon bg-primary rounded-circle p-3"
              aria-hidden="true"
            ></span>

            <span className="visually-hidden">Siguiente</span>
          </button>
        </>
      )}
    </div>
  );
};

export default Carousel;
